import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { getStarIconClass } from './star-rating.util';

@Component({
  selector: 'app-star-rating',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './star-rating.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./star-rating.component.css'],
})
export class StarRatingComponent {
  @Input() value = 0;

  readonly stars = [1, 2, 3, 4, 5];

  iconClass(position: number): string {
    return getStarIconClass(position, this.value || 0);
  }
}
